module.exports = __webpack_public_path__ + "static/media/DocuWareLogBig.2901afc8.svg";